import { logEvent } from 'commons/utils/tracking';
import {
  MENU_SECONDARY_STATS_CLICK,
  MENU_SECONDARY_STATS_PRODUCTS_CLICK,
  MENU_SECONDARY_STATS_PAYMENTS_CLICK,
  MENU_SECONDARY_STATS_ACQUISITION_CLICK,
  MENU_SECONDARY_STATS_SHIPPING_CLICK,
  MENU_SECONDARY_STATS_GENERAL_CLICK,
  MENU_SECONDARY_STATS_LIVEVIEW_CLICK,
  MENU_SECONDARY_STATS_COUPONS_CLICK,
  MENU_SECONDARY_STATS_SEARCH_INSIGHTS_CLICK,
  MENU_SECONDARY_STATS_VISITS_CLICK,
  MENU_SECONDARY_STATS_SALES_CLICK,
  MENU_SECONDARY_STATS_PRODUCTS_V2_CLICK,
} from 'config/trackingEvents';

export const menuSecondaryStatsClick = () => {
  logEvent(MENU_SECONDARY_STATS_CLICK, {});
};

export const menuSecondaryStatsProductsClick = () => {
  logEvent(MENU_SECONDARY_STATS_PRODUCTS_CLICK, {});
};

export const menuSecondaryStatsPaymentsClick = () => {
  logEvent(MENU_SECONDARY_STATS_PAYMENTS_CLICK, {});
};

export const menuSecondaryStatsAcquisitionClick = () => {
  logEvent(MENU_SECONDARY_STATS_ACQUISITION_CLICK, {});
};

export const menuSecondaryStatsShippingClick = () => {
  logEvent(MENU_SECONDARY_STATS_SHIPPING_CLICK, {});
};

export const menuSecondaryStatsGeneralClick = () => {
  logEvent(MENU_SECONDARY_STATS_GENERAL_CLICK, {});
};

export const menuSecondaryStatsLiveviewClick = () => {
  logEvent(MENU_SECONDARY_STATS_LIVEVIEW_CLICK, {});
};

export const menuSecondaryStatsCouponsClick = () => {
  logEvent(MENU_SECONDARY_STATS_COUPONS_CLICK, {});
};

export const menuSecondaryStatsSearchInsightsClick = () => {
  logEvent(MENU_SECONDARY_STATS_SEARCH_INSIGHTS_CLICK, {});
};

export const menuSecondaryStatsVisitsClick = () => {
  logEvent(MENU_SECONDARY_STATS_VISITS_CLICK, {});
};

export const menuSecondaryStatsSalesClick = () => {
  logEvent(MENU_SECONDARY_STATS_SALES_CLICK, {});
};

export const menuSecondaryStatsProductsV2Click = () => {
  logEvent(MENU_SECONDARY_STATS_PRODUCTS_V2_CLICK, {});
};
